export default __webpack_public_path__ + "70ab914b5a963f77ff8a37b4b1397a7a.png";